import type { FC } from 'react'
import React, { memo } from 'react'
import { useUserRegion } from '@frontend/components/agromarket/components/RegionSelector'
import { IndexPageSection, SectionBlock, SectionHeading } from '@/pages/IndexPage/components'
import { BecomePartners, Manufacturers, OurPartners } from './components'
import { messages } from './messages'

const Partners: FC = () => {
  const { userRegion } = useUserRegion()

  return (
    <>
      <IndexPageSection backgroundColor="grey">
        <SectionBlock>
          <SectionHeading header={messages.becomePartnersHeader} />
          <BecomePartners region={userRegion} />
        </SectionBlock>
      </IndexPageSection>

      <IndexPageSection>
        <SectionBlock>
          <SectionHeading header={messages.ourParntersHeader} />
        </SectionBlock>
        <SectionBlock withoutRightMarginMobile>
          <OurPartners />
        </SectionBlock>
      </IndexPageSection>

      <IndexPageSection>
        <Manufacturers />
      </IndexPageSection>
    </>
  )
}

export default memo(Partners)
